/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import translate from "../utils/translation"

function SEO({ description, lang, meta, title, images, slug }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            imageRoot
            ogImage
            siteUrl
          }
        }
      }
    `
  )

  const metaDescription = description || translate('site.description', lang)
  const imageRoot = site.siteMetadata.imageRoot
  const ogImage = site.siteMetadata.ogImage
  const ogUrl = site.siteMetadata.siteUrl + slug

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`${translate('site.name', lang)} | %s`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:image`,
          content: ogImage,
        },
        {
          property: `og:url`,
          content: ogUrl,
        },
      ].concat(meta)}
    >
      {
        images.map(
          (image, index) => (
            <link key={index} rel="preload" href={`${imageRoot}/${image}`} as="image"/>
          )
        )
      }
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
  images: [],
  slug: ``
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
